"use client";

/** Visiting a page a "New" marker points at clears the marker. No UI. */
import { usePathname } from "next/navigation";
import { useSeenOnVisit } from "@/lib/use-announcements";

export default function AnnouncementsSeenOnVisit() {
  useSeenOnVisit(usePathname());
  return null;
}
